"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenderFilterOption = exports.WearableGender = void 0;
const validation_1 = require("../validation");
var WearableGender;
(function (WearableGender) {
    WearableGender["MALE"] = "male";
    WearableGender["FEMALE"] = "female";
})(WearableGender = exports.WearableGender || (exports.WearableGender = {}));
var GenderFilterOption;
(function (GenderFilterOption) {
    GenderFilterOption["MALE"] = "male";
    GenderFilterOption["FEMALE"] = "female";
    GenderFilterOption["UNISEX"] = "unisex";
})(GenderFilterOption = exports.GenderFilterOption || (exports.GenderFilterOption = {}));
(function (WearableGender) {
    WearableGender.schema = {
        type: 'string',
        enum: Object.values(WearableGender)
    };
    WearableGender.validate = (0, validation_1.generateLazyValidator)(WearableGender.schema);
})(WearableGender = exports.WearableGender || (exports.WearableGender = {}));
//# sourceMappingURL=wearable-gender.js.map